import {
  ACR,
  ACRLong,
  ACTIVE_DIRECTORY,
  ACTIVE_DIRECTORYLong,
  ACUNETIX,
  ACUNETIXLong,
  ADAPTIVESHIELD,
  ADAPTIVESHIELDLong,
  ANOMALI_THREAT_INTEL,
  ANOMALI_THREAT_INTELLong,
  APIIRO,
  APIIROLong,
  APPCHECK,
  APPCHECKLong,
  APPKNOX,
  APPKNOXLong,
  APPKNOX_DARK,
  APPKNOX_LONG_DARK,
  AQUA,
  AQUALong,
  ARMS,
  ARMSLong,
  ARMS_DARK,
  ARMS_LONG_DARK,
  ARCTIC_WOLF,
  ARCTIC_WOLFLong,
  ARCTIC_WOLF_DARK,
  ARCTIC_WOLF_LONG_DARK,
  ARNICA,
  ARNICALong,
  ASTRIX,
  ASTRIXLong,
  AUTH0,
  AWS,
  AWSLong,
  AXONIUS,
  AXONIUSLong,
  AZURE,
  AZURELong,
  AZUREDEVOPS,
  AZUREDEVOPSLong,
  AZUREDEVOPS_DARK,
  AZUREDEVOPS_LONG_DARK,
  AZURERESOURCES,
  AZURERESOURCESLong,
  BACKSTAGE,
  BACKSTAGELong,
  BACKSTAGE_DARK,
  BACKSTAGE_LONG_DARK,
  BIGFIX,
  BIGFIXLong,
  BITSIGHT,
  BITSIGHTLong,
  BISHOPFOX,
  BISHOPFOXLong,
  BLACK_KITE,
  BLACK_KITELong,
  BLACK_KITE_DARK,
  BLACK_KITE_LONG_DARK,
  BLACKDUCK,
  BLACKDUCKLong,
  BLOODHOUND,
  BLOODHOUNDLong,
  BLUBRACKET,
  BLUBRACKETLong,
  BMCHELIX,
  BMCHELIXLong,
  BRIGHTSECURITY,
  BRIGHTSECURITYLong,
  BUGCROWD,
  BUGCROWDLong,
  BURPSUITE,
  BURPSUITELong,
  CENSYS,
  CENSYSLong,
  CHECKMARX,
  CHECKMARXLong,
  CHECKPOINTHARMONY,
  CHECKPOINTHARMONYLong,
  CHECKPINTHARMONY_DARK,
  CHECKPINTHARMONY_LONG_DARK,
  CHECKPOINT,
  CHECKPOINTLong,
  CHECKPOINT_DARK,
  CHECKPOINT_LONG_DARK,
  CIDER,
  CIDERLong,
  CISCO,
  CISCOLong,
  CISCO_DARK,
  CISCO_LONG_DARK,
  CLAROTY,
  CLAROTYLong,
  CLOVER,
  CLOVERLong,
  Cloud,
  CLOUDDEFENDER,
  CLOUDDEFENDERLong,
  CodeRepository,
  CodeRepository_DARK,
  COBALTIO,
  COBALTIOLong,
  CONNECTWISE,
  CONNECTWISELong,
  CORTEX,
  CORTEXLong,
  CORTEXXPANSE,
  CORTEXXPANSELong,
  COVERITY,
  COVERITYLong,
  CROWDSTRIKE,
  CROWDSTRIKELong,
  CYCODE,
  CYCODELong,
  CYCOGNITO,
  CYCOGNITOLong,
  CYERA,
  CYERALong,
  CYMULATE,
  CYMULATELong,
  CWE,
  CWELong,
  Datacenter,
  DATACENTERLong,
  DATATHEOREM,
  DATATHEOREMLong,
  DEFENDER,
  DEFENDERLong,
  DEFENDER_EASM,
  DEFENDER_EASMLong,
  DEFAULT as DEFAULT_DATA_SOURCE,
  DEPENDENCYTRACK,
  DEPENDENCYTRACKLong,
  DEPENDENCYTRACK_DARK,
  DEPENDENCYTRACK_LONG_DARK,
  DEPTHFIRST,
  DEPTHFIRSTLong,
  DEPTHFIRST_DARK,
  DEPTHFIRST_LONG_DARK,
  DETECTIFY,
  DETECTIFYLong,
  DEVICE42,
  DEVICE42Long,
  DOME9,
  DOME9Long,
  ECR,
  ECRLong,
  EDGESCAN,
  EDGESCANLong,
  ELASTICCLOUDSECURITY,
  ELASTICCLOUDSECURITYLong,
  EMAIL,
  EMAIL_DARK,
  ENDORLABS,
  ENDORLABSLong,
  ENTRAID,
  ENTRAIDLong,
  ENTROSECURITY,
  ENTROSECURITYLong,
  ERMETIC,
  ERMETICLong,
  FIBERY,
  FIBERYLong,
  FIXINATOR,
  FIXINATORLong,
  FLEET,
  FLEETLong,
  FLEXERA,
  FLEXERALong,
  FORTRAVM,
  FORTRAVMLong,
  FORTIFY,
  FORTIFYLong,
  FORTIFYDATA,
  FORTIFYDATALong,
  FOSSA,
  FOSSALong,
  GCP,
  GCPLong,
  GEM,
  GEMLong,
  GIT,
  GITLong,
  GITGUARDIAN,
  GITGUARDIANLong,
  GITGUARDIAN_DARK,
  GITGUARDIAN_LONG_DARK,
  GITLAB_SCA,
  GITLAB_SCALong,
  GITHUBACTIONS,
  GITHUBACTIONSLong,
  GITHUBACTIONSLong_DARK,
  GITLEAKS,
  GITLEAKSLong,
  GITLEAKS_DARK,
  GITLEAKS_LONG_DARK,
  GOOGLE,
  GOOGLE_THREAT_INTEL,
  GOOGLE_THREAT_INTELLong,
  GOOGLECONTAINERREGISTRY,
  GRIP,
  GRIPLong,
  GRIP_DARK,
  GRIP_LONG_DARK,
  GUARDIUM,
  GUARDIUMLong,
  GYTPOL,
  GYTPOLLong,
  HACKER1,
  HACKER1Long,
  HARBOR,
  HARBORLong,
  HASHICORP,
  HASHICORPLong,
  HASHICORP_DARK,
  HASHICORP_LONG_DARK,
  HEXNODE,
  HEXNODELong,
  HEXNODE_DARK,
  HEXNODE_LONG_DARK,
  HORIZON3,
  HORIZON3Long,
  HORIZON3_DARK,
  HORIZON3_LONG_DARK,
  INSPECTIV,
  INSPECTIVLong,
  INTRUDER,
  INTRUDERLong,
  INTUNE,
  INTUNELong,
  INVICTI,
  INVICTILong,
  INVICTI_DARK,
  INVICTI_LONG_DARK,
  IONIX,
  IONIXLong,
  IONIX_DARK,
  IONIX_LONG_DARK,
  IRU,
  IRULong,
  IRU_DARK,
  IRU_LONG_DARK,
  IVANTI,
  IVANTILong,
  JFROG,
  JFROGLong,
  JFROGCONTAINERREGISTRY,
  JFROGXRAY,
  JFROGXRAYLong,
  JIRA,
  JIRALong,
  JIRA_ON_PREM,
  JIRA_ON_PREMLong,
  JIT,
  JITLong,
  KENNASECURITY,
  KENNASECURITYLong,
  KNOWBE4,
  KNOWBE4Long,
  KODEMSECURITY,
  KODEMSECURITYLong,
  KUBERNETES,
  KUBERENETESLong,
  LACEWORK,
  LACEWORKLong,
  LANSWEEPER,
  LANSWEEPERLong,
  LAYERX,
  LAYERXLong,
  LEGIT,
  LEGITLong,
  MAN,
  MANLong,
  MAN_DARK,
  MANDIANT,
  MANDIANTLong,
  MANAGEENGINE,
  MANAGEENGINELong,
  MEND,
  MENDLong,
  MICROSOFT,
  MICROSOFTLong,
  MICROSOFT_ENTRA_ID,
  MICROSOFT_ENTRA_IDLong,
  MISP,
  MISPLong,
  MONDAY,
  MONDAYLong,
  MONDAY_DARK,
  MONDAY_LONG_DARK,
  MONITOR,
  MONITOR_DARK,
  MSTEAMS,
  MSTEAMSLong,
  NAUTOBOT,
  NAUTOBOTLong,
  NETSKOPE,
  NETSKOPELong,
  NETSPYGLASS,
  NETSPYGLASSLong,
  NETSPI,
  NETSPILong,
  NEXUS,
  NONAME,
  NONAMELong,
  NOMASECURITY,
  NOMASECURITY_LONG,
  NOMASECURITY_DARK,
  NOMASECURITY_LONG_DARK,
  NOW_SECURE,
  NOW_SECURELong,
  NOW_SECURE_DARK,
  NOW_SECURE_LONG_DARK,
  NTSPRKR,
  NTSPRKRLong,
  NTTGN,
  NTTGNLong,
  OCI,
  OCILong,
  OKTA,
  OKTALong,
  OKTA_DARK,
  OKTA_LONG_DARK,
  OLIGO,
  OLIGOLong,
  OASIS,
  OASISLong,
  ONAPSIS,
  ONAPSISLong,
  ONAPSIS_DARK,
  ONAPSIS_LONG_DARK,
  OOMNITZA,
  OOMNITZALong,
  OOMNITZA_DARK,
  OOMNITZA_LONG_DARK,
  OPENCTI,
  OPENCTILONG,
  OPENCTI_DARK,
  OPENCTI_LONG_DARK,
  OPSLEVEL,
  OPSLEVELLong,
  OPSLEVEL_DARK,
  OPSLEVEL_LONG_DARK,
  ORCA,
  ORCALong,
  OXSECURITY,
  OXSECURITYLong,
  PALOALTOIOT,
  PALOALTOIOTLong,
  PRISMA,
  PRISMALong,
  PROJECT_DISCOVERY,
  PROJECT_DISCOVERYLong,
  QUALYS,
  QUALYSLong,
  RAPID7,
  RAPID7Long,
  RAP,
  RECORDEDFUTURE,
  RECORDEDFUTURELong,
  REDHAT,
  REDHAT_LONG,
  REDHAT_DARK,
  REDHAT_LONG_DARK,
  SALESFORCE,
  SALESFORCELong,
  SALTSECURITY,
  SALTSECURITYLong,
  SAP,
  SAPLong,
  SECURITYSCORECARD,
  SECURITYSCORECARDLong,
  SEEMPLICITY,
  SEEMPLICITYLong,
  SEEMPLICITY_DARK,
  SEEMPLICITY_LONG_DARK,
  SEMGREP,
  SEMGREPLong,
  SENTRA,
  SENTRALong,
  SENTINELONE,
  SENTINELONELong,
  SERVICENOW,
  SERVICENOWLong,
  SERVICENOW_CMDB,
  SERVICENOW_CMDBLong,
  SFB,
  SFBLong,
  SFB_DARK,
  SFB_LONG_DARK,
  SHAREPOINT,
  SHAREPOINTLong,
  SHAREPOINT_LONG_DARK,
  SHODAN,
  SHODANLong,
  SLACK,
  SLACKLong,
  SLACK_DARK,
  SLACK_LONG_DARK,
  SNOWFLAKE,
  SNOWFLAKELong,
  SNOWFLAKE_TRUST_CENTER,
  SNOWFLAKE_TRUST_CENTERLong,
  SNOWFLAKE_TRUST_CENTER_DARK,
  SNOWFLAKE_TRUST_CENTER_LONG_DARK,
  SNYK,
  SNYKLong,
  SOCKET,
  SOCKETLong,
  SONARQUBE,
  SONARQUBELong,
  SONATYPE,
  SONATYPELong,
  SONRAI,
  SONRAILong,
  SPLUNKIMPORTER,
  SPLUNKIMPORTERLong,
  STREAMSECURITY,
  STREAMSECURITYLong,
  SYSDIG,
  SYSDIGLong,
  SYNACK,
  SYNACKLong,
  TANIUM,
  TANIUMLong,
  TEN,
  TENLong,
  TENPCI,
  TENPCILong,
  THREATCONNECT,
  THREATCONNECTLong,
  THREATMODELER,
  THREATMODELERLong,
  THREATMODELER_DARK,
  THREATMODELER_LONG_DARK,
  TRACEABLE,
  TRACEABLELong,
  TRENDMICRO,
  TRENDMICROLong,
  TRIVY,
  TRIVYLong,
  TRUFFELHOG,
  TRUFFELHOGLong,
  UBUNTUESM,
  UBUNTUESMLong,
  UPTYCS,
  UPTYCSLong,
  UPWIND,
  UPWINDLong,
  VALENCESECURITY,
  VALENCESECURITYLong,
  VERACODE,
  VERACODELong,
  VEZA,
  VEZALong,
  VICARIUS,
  VICARIUSLong,
  WHITEHAT,
  WHITEHATLong,
  WIZ,
  WIZLong,
  WORKDAY,
  WORKDAYLong,
  WORKSPACE,
  WORKSPACELong,
  WSO,
  WSOLong,
  WHITESOURCE_DARK,
  WHITESOURCE_LONG_DARK,
  XMCYBER,
  XMCYBERLong,
  ZAFRANSECURITY,
  ZAFRANSECURITYLong,
  ZOOM,
  ZOOMLong,
  ADAPTIVE_SHIELD_DARK,
  ADAPTIVE_SHIELD_LONG_DARK,
  ANOMALI_DARK,
  ANOMALI_LONG_DARK,
  AZURE_DARK,
  AZURE_LONG_DARK,
  AWS_DARK,
  AWS_LONG_DARK,
  AMAZONECR_DARK,
  AMAZONECR_LONG_DARK,
  ACTIVE_DIRECTORY_DARK,
  ACTIVE_DIRECTORY_LONG_DARK,
  ACUNETIX_DARK,
  ACUNETIX_LONG_DARK,
  APIIRO_DARK,
  APIIRO_LONG_DARK,
  AQUA_DARK,
  AQUA_LONG_DARK,
  ASTRIX_DARK,
  ASTRIX_LONG_DARK,
  AXONIUS_DARK,
  AXONIUS_LONG_DARK,
  BIGFIX_DARK,
  BIGFIX_LONG_DARK,
  BISHOPFOX_DARK,
  BISHOPFOX_LONG_DARK,
  BLACKDUCK_DARK,
  BLACKDUCK_LONG_DARK,
  BLOODHOUND_DARK,
  BLOODHOUND_LONG_DARK,
  BUGCROWD_DARK,
  BUGCROWD_LONG_DARK,
  BURPSUITE_DARK,
  BURPSUITE_LONG_DARK,
  CENSYS_DARK,
  CENSYS_LONG_DARK,
  CIDER_DARK,
  CIDER_LONG_DARK,
  CIRCLECI_DARK,
  CIRCLECI_LONG_DARK,
  CLAROTY_DARK,
  CLAROTY_LONG_DARK,
  CLOVER_DARK,
  CLOVER_LONG_DARK,
  CLOUDDEFENDER_DARK,
  CLOUDDEFENDER_LONG_DARK,
  CORTEXXPANSE_DARK,
  CORTEXXPANSE_LONG_DARK,
  COVERITY_DARK,
  COVERITY_LONG_DARK,
  CROWDSTRIKE_DARK,
  CROWDSTRIKE_LONG_DARK,
  CYCODE_DARK,
  CYCODE_LONG_DARK,
  CYERA_DARK,
  CYERA_LONG_DARK,
  CYMULATE_DARK,
  CYMULATE_LONG_DARK,
  CWE_DARK,
  CWE_LONG_DARK,
  DATATHEOREM_DARK,
  DATATHEOREM_LONG_DARK,
  DEFENDER_DARK,
  DEFENDER_LONG_DARK,
  DEFENDER_EASM_DARK,
  DEFENDER_EASM_LONG_DARK,
  DETECTIFY_DARK,
  DETECTIFY_LONG_DARK,
  EDGESCAN_DARK,
  EDGESCAN_LONG_DARK,
  ELASTIC_CLOUD_SECURITY_DARK,
  ELASTIC_CLOUD_SECURITY_LONG_DARK,
  ELASTIC_SECURITY_DARK,
  ELASTIC_SECURITY_LONG_DARK,
  ENDORLABS_DARK,
  ENDORLABS_LONG_DARK,
  ERMETIC_DARK,
  ERMETIC_LONG_DARK,
  FIXINATOR_DARK,
  FIXINATOR_LONG_DARK,
  FLEXERA_DARK,
  FLEXERA_LONG_DARK,
  FORTIFY_DARK,
  FORTIFY_LONG_DARK,
  FORTIFYDATA_DARK,
  FORTIFYDATA_LONG_DARK,
  FORTRAVM_DARK,
  FORTRAVM_LONG_DARK,
  FOSSA_DARK,
  FOSSA_LONG_DARK,
  GCP_DARK,
  GCP_LONG_DARK,
  GEM_DARK,
  GEM_LONG_DARK,
  GIT_DARK,
  GIT_LONG_DARK,
  GUARDIUM_DARK,
  GYTPOL_DARK,
  GYTPOL_LONG_DARK,
  HARBOR_DARK,
  HARBOR_LONG_DARK,
  INSPECTIV_DARK,
  INSPECTIV_LONG_DARK,
  INTRUDER_DARK,
  INTRUDER_LONG_DARK,
  JFROGXRAY_DARK,
  JFROGXRAY_LONG_DARK,
  JIRA_DARK,
  JIRA_LONG_DARK,
  JIT_DARK,
  JIT_LONG_DARK,
  KODEMSECURITY_DARK,
  KODEMSECURITY_LONG_DARK,
  LACEWORK_DARK,
  LACEWORK_LONG_DARK,
  LANSWEEPER_DARK,
  LANSWEEPER_LONG_DARK,
  LAYERX_DARK,
  LAYERX_LONG_DARK,
  LEGIT_DARK,
  LEGIT_LONG_DARK,
  MANAGEENGINE_DARK,
  MANAGEENGINE_LONG_DARK,
  MEND_DARK,
  MEND_LONG_DARK,
  MICROSOFT_DARK,
  MICROSOFT_LONG_DARK,
  MICROSOFT_ENTRA_ID_DARK,
  MICROSOFT_ENTRA_ID_LONG_DARK,
  NETSPI_DARK,
  NETSPI_LONG_DARK,
  NETSPYGLASS_DARK,
  NETSPYGLASS_LONG_DARK,
  NONAME_DARK,
  NONAME_LONG_DARK,
  OCI_DARK,
  OCI_LONG_DARK,
  OLIGO_DARK,
  OLIGO_LONG_DARK,
  OASIS_DARK,
  OASIS_LONG_DARK,
  ORCA_DARK,
  ORCA_LONG_DARK,
  OXSECURITY_DARK,
  OXSECURITY_LONG_DARK,
  PALOALTOIOT_DARK,
  PALOALTOIOT_LONG_DARK,
  PRISMA_DARK,
  PRISMA_LONG_DARK,
  PROJECT_DISCOVERY_DARK,
  PROJECT_DISCOVERY_LONG_DARK,
  QUALYS_DARK,
  QUALYS_LONG_DARK,
  RECO,
  RECOLong,
  RECO_DARK,
  RECO_LONG_DARK,
  RECORDEDFUTURE_DARK,
  RECORDEDFUTURE_LONG_DARK,
  SALTSECURITY_DARK,
  SALTSECURITY_LONG_DARK,
  SECURITYSCORECARD_DARK,
  SECURITYSCORECARD_LONG_DARK,
  SEMGREP_DARK,
  SEMGREP_LONG_DARK,
  SENTINELONE_DARK,
  SENTINELONE_LONG_DARK,
  SENTRA_DARK,
  SENTRA_LONG_DARK,
  SERVICENOW_CMDB_DARK,
  SERVICENOW_CMDB_LONG_DARK,
  SNYK_DARK,
  SNYK_LONG_DARK,
  SOCKET_DARK,
  SOCKET_LONG_DARK,
  SONARQUBE_DARK,
  SONARQUBE_LONG_DARK,
  SONATYPE_DARK,
  SONATYPE_LONG_DARK,
  SONRAI_DARK,
  SONRAI_LONG_DARK,
  SPLUNKIMPORTER_DARK,
  SPLUNKIMPORTER_LONG_DARK,
  STREAMSECURITY_DARK,
  STREAMSECURITY_LONG_DARK,
  SYNACK_DARK,
  SYNACK_LONG_DARK,
  SYSDIG_DARK,
  SYSDIG_LONG_DARK,
  TANIUM_DARK,
  TANIUM_LONG_DARK,
  TENPCI_DARK,
  TENPCI_LONG_DARK,
  TEN_DARK,
  TEN_LONG_DARK,
  THREATCONNECT_DARK,
  THREATCONNECT_LONG_DARK,
  TRACEABLE_DARK,
  TRACEABLE_LONG_DARK,
  TRIVY_DARK,
  TRIVY_LONG_DARK,
  UBUNTUESM_DARK,
  UBUNTUESM_LONG_DARK,
  UPTYCS_DARK,
  UPTYCS_LONG_DARK,
  VALENCESECURITY_DARK,
  VALENCESECURITY_LONG_DARK,
  VERACODE_DARK,
  VERACODE_LONG_DARK,
  VEZA_DARK,
  VEZA_LONG_DARK,
  VICARIUS_DARK,
  VICARIUS_LONG_DARK,
  WHITEHAT_DARK,
  WHITEHAT_LONG_DARK,
  WIZ_DARK,
  WIZ_LONG_DARK,
  WORKDAY_DARK,
  WORKDAY_LONG_DARK,
  WORKSPACE_DARK,
  WORKSPACE_LONG_DARK,
  XMCYBER_DARK,
  XMCYBER_LONG_DARK,
  ZSCALER_DARK,
  ZSCALER_LONG_DARK,
  ZENDESK,
  ZENDESKLong,
  ZENDESK_DARK,
  ZENDESK_LONG_DARK,
  BRIGHT_SECURITY_DARK,
  BRIGHT_SECURITY_LONG_DARK,
  DEVICE42_DARK,
  DEVICE42_LONG_DARK,
  FLEETDM_DARK,
  FLEETDM_LONG_DARK,
  DOME9_DARK,
  DOME9_LONG_DARK,
  CHECKMARX_AST_DARK,
  CHECKMARX_GO_DARK,
  CHECKMARX_GO_LONG_DARK,
  CHECKMARX_ONE_DARK,
  CHECKMARX_ONE_LONG_DARK,
  CHECKMARX_SAST_DARK,
  CHECKMARX_SAST_LONG_DARK,
  RAPID7_DARK,
  RAPID7_LONG_DARK,
  CORTEX_IO_DARK,
  CORTEX_IO_LONG_DARK,
  HACKER1_DARK,
  HACKER1_LONG_DARK,
  COBALT_IO_DARK,
  COBALT_IO_LONG_DARK,
  ENTRO_SECURITY_DARK,
  ENTRO_SECURITY_LONG_DARK,
  NETSPARKER_DARK,
  NETSPARKER_LONG_DARK,
  TREND_MICRO_DARK,
  TREND_MICRO_LONG_DARK,
  ZAFRAN_SECURITY_DARK,
  ZAFRAN_SECURITY_LONG_DARK,
  ARNICA_LONG_DARK,
  ARNICA_DARK,
  BITSIGHT_LONG_DARK,
  BITSIGHT_DARK,
  BMCHELIX_LONG_DARK,
  BMCHELIX_DARK,
  CONNECTWISE_DARK,
  CONNECTWISE_LONG_DARK,
  CYCOGNITO_DARK,
  CYCOGNITO_LONG_DARK,
  FIBERY_DARK,
  FIBERY_LONG_DARK,
  GITLAB_DARK,
  GITLAB_LONG_DARK,
  KNOWBE4_DARK,
  KNOWBE4_LONG_DARK,
  NAUTOBOT_DARK,
  NAUTOBOT_LONG_DARK,
  NETSKOPE_DARK,
  NETSKOPE_LONG_DARK,
  TRUFFLEHOG_DARK,
  TRUFFLEHOG_LONG_DARK,
  UPWIND_DARK,
  UPWIND_LONG_DARK,
  MANDIANT_DARK,
  MANDIANT_LONG_DARK,
  NTTGN_DARK,
  NTTGN_LONG_DARK,
  INTUNE_LONG_DARK,
  INTUNE_DARK,
  JFROG_DARK,
  JFROG_LONG_DARK,
  KUBERNETES_DARK,
  KUBERNETES_LONG_DARK,
  NEXUS_DARK,
  Cloud_DARK,
  UPGUARD,
  UPGUARD_DARK,
  UPGUARDLong,
  UPGUARD_LONG_DARK,
  IMPERVALong,
  IMPERVA_DARK,
  IMPERVA_LONG_DARK,
  IMPERVA,
  RUNZERO,
  RUNZEROLong,
  RUNZERO_DARK,
  RUNZERO_LONG_DARK,
  CYVER,
  CYVERLong,
  CYVER_DARK,
  CYVER_LONG_DARK,
  OMNISSA,
  OMNISSALong,
  OMNISSA_DARK,
  OMNISSA_LONG_DARK,
  MIGGO,
  MIGGO_LONG,
  MIGGO_DARK,
  MIGGO_LONG_DARK,
  STEPSECURITY,
  STEPSECURITYLong,
  STEPSECURITY_DARK,
  STEPSECURITY_LONG_DARK,
  SARIF,
  SARIFLong,
  SARIF_DARK,
  SARIF_LONG_DARK,
  ESCAPESECURITY_DARK,
  ESCAPESECURITY_LONG_DARK,
  ESCAPESECURITY,
  ESCAPESECURITYLong,
  EUVD,
  EUVDLong,
  EUVD_DARK,
  EUVD_LONG_DARK,
  STACKHAWK,
  STACKHAWKLong,
  STACKHAWK_DARK,
  STACKHAWK_LONG_DARK,
  CORTEX_CLOUD,
  CORTEX_CLOUDLong,
  CORTEX_CLOUD_DARK,
  CORTEX_CLOUD_LONG_DARK,
  CORTEX_XDR,
  CORTEX_XDRLong,
  CORTEX_XDR_DARK,
  CORTEX_XDR_LONG_DARK,
  OBSIDIAN,
  OBSIDIANLong,
  OBSIDIAN_DARK,
  OBSIDIAN_LONG_DARK,
} from "./DataSourceIcons/DataSourceIcons";

import {
  EPSS,
  EPSSLONG,
  VULNCHECK_KEV,
  VULNCHECK_KEVLong,
  NVD_DARK,
  NVD_LONG_DARK,
  NVD,
  NVDLong,
  CISA_KEV,
  CISA_KEVLong,
  CISA_KEV_DARK,
  CISA_KEV_LONG_DARK,
  VULNCHECK_KEV_DARK,
  VULNCHECK_KEV_LONG_DARK,
} from "./ThreatIntelligenceIcons/ThreatIntelligenceIcons";

import {
  ZSCALER,
  ZSCALERLong,
  DOCKER,
  DOCKERLong,
  DOCKER_DARK,
  DOCKER_LONG_DARK,
  BITBUCKET,
  BITBUCKETLong,
  BITBUCKET_DARK,
  BITBUCKET_LONG_DARK,
  BOX,
  BOXLong,
  BOX_DARK,
  BOX_LONG_DARK,
  CONFLUENCE,
  CONFLUENCELong,
  CONFLUENCE_DARK,
  CONFLUENCE_LONG_DARK,
  DATADOG,
  DATADOGLong,
  DATADOG_DARK,
  DATADOG_LONG_DARK,
  JENKINS,
  JENKINSLong,
  JENKINS_DARK,
  JENKINS_LONG_DARK,
  ASANA,
  ASANALong,
  ASANA_DARK,
  ASANA_LONG_DARK,
  ATLAS,
  ATLASLong,
  ATLAS_DARK,
  ATLAS_LONG_DARK,
  CIRCLECI,
  CIRCLECILong,
  DOCUSIGN,
  DOCUSIGNLong,
  DOCUSIGN_DARK,
  DOCUSIGN_LONG_DARK,
  GOOGLEWORKSPACE,
  GOOGLEWORKSPACELong,
  LUCIDCHART,
  LUCIDCHARTLong,
  LUCIDCHART_DARK,
  LUCIDCHART_LONG_DARK,
  NOTION,
  NOTIONLong,
  NOTION_DARK,
  NOTION_LONG_DARK,
  PAGERDUTY,
  PAGERDUTYLong,
  PAGERDUTY_DARK,
  PAGERDUTY_LONG_DARK,
  SMARTSHEET,
  SMARTSHEETLong,
  SMARTSHEET_DARK,
  SMARTSHEET_LONG_DARK,
  TABLEAU,
  TABLEAULong,
  TABLEAU_DARK,
  TABLEAU_LONG_DARK,
  TRELLO,
  TRELLOLong,
  TRELLO_DARK,
  TRELLO_LONG_DARK,
} from "./CloudProviderIcons/CloudProviderIcons";

import {
  IVANTI_DARK,
  IVANTI_LONG_DARK,
  SERVICENOW_DARK,
  SERVICENOW_LONG_DARK,
  FRESHSERVICE,
  FRESHSERVICELong,
  FRESHSERVICE_DARK,
  FRESHSERVICE_LONG_DARK,
  SERVICE_DESK_ON_PREM,
  SERVICE_DESK_ON_PREMLong,
  SERVICE_DESK_ON_PREM_DARK,
  SERVICE_DESK_ON_PREM_LONG_DARK,
  TEAMDYNAMIX,
  TEAMDYNAMIXLong,
  TEAMDYNAMIX_DARK,
  TEAMDYNAMIX_LONG_DARK,
} from "./TicketingIcons/TicketingIcons";

export type DataSourceIcon = {
  S?: string;
  L?: string;
};
export const dataSourceIcons: Record<
  string,
  { LIGHT: DataSourceIcon; DARK: DataSourceIcon | null }
> = {
  "Cyver.io": {
    LIGHT: {
      S: CYVER,
      L: CYVERLong,
    },
    DARK: { S: CYVER_DARK, L: CYVER_LONG_DARK },
  },
  runZero: {
    LIGHT: {
      S: RUNZERO,
      L: RUNZEROLong,
    },
    DARK: { S: RUNZERO_DARK, L: RUNZERO_LONG_DARK },
  },
  "Seemplicity Scope Validator": {
    LIGHT: {
      S: SEEMPLICITY,
      L: SEEMPLICITYLong,
    },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  "Seemplicity SLA Validator": {
    LIGHT: {
      S: SEEMPLICITY,
      L: SEEMPLICITYLong,
    },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  "Seemplicity Scope To Finding": {
    LIGHT: {
      S: SEEMPLICITY,
      L: SEEMPLICITYLong,
    },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  "Seemplicity Compliance Validator": {
    LIGHT: {
      S: SEEMPLICITY,
      L: SEEMPLICITYLong,
    },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  "Seemplicity Top Vulnerable Assets": {
    LIGHT: {
      S: SEEMPLICITY,
      L: SEEMPLICITYLong,
    },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  Backstage: {
    LIGHT: { S: BACKSTAGE, L: BACKSTAGELong },
    DARK: { S: BACKSTAGE_DARK, L: BACKSTAGE_LONG_DARK },
  },
  Bitsight: {
    LIGHT: { S: BITSIGHT, L: BITSIGHTLong },
    DARK: { S: BITSIGHT_DARK, L: BITSIGHT_LONG_DARK },
  },
  "Black Kite": {
    LIGHT: { S: BLACK_KITE, L: BLACK_KITELong },
    DARK: { S: BLACK_KITE_DARK, L: BLACK_KITE_LONG_DARK },
  },
  Seemplicity: {
    LIGHT: { S: SEEMPLICITY, L: SEEMPLICITYLong },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  "Valence Security": {
    LIGHT: { S: VALENCESECURITY, L: VALENCESECURITYLong },
    DARK: { S: VALENCESECURITY_DARK, L: VALENCESECURITY_LONG_DARK },
  },
  OpenCTI: {
    LIGHT: { S: OPENCTI, L: OPENCTILONG },
    DARK: { S: OPENCTI_DARK, L: OPENCTI_LONG_DARK },
  },
  Veza: {
    LIGHT: { S: VEZA, L: VEZALong },
    DARK: { S: VEZA_DARK, L: VEZA_LONG_DARK },
  },
  "Elastic Cloud Security": {
    LIGHT: { S: ELASTICCLOUDSECURITY, L: ELASTICCLOUDSECURITYLong },
    DARK: {
      S: ELASTIC_CLOUD_SECURITY_DARK,
      L: ELASTIC_CLOUD_SECURITY_LONG_DARK,
    },
  },
  Device42: {
    LIGHT: { S: DEVICE42, L: DEVICE42Long },
    DARK: { S: DEVICE42_DARK, L: DEVICE42_LONG_DARK },
  },
  "Ubuntu ESM": {
    LIGHT: { S: UBUNTUESM, L: UBUNTUESMLong },
    DARK: { S: UBUNTUESM_DARK, L: UBUNTUESM_LONG_DARK },
  },
  Lansweeper: {
    LIGHT: { S: LANSWEEPER, L: LANSWEEPERLong },
    DARK: { S: LANSWEEPER_DARK, L: LANSWEEPER_LONG_DARK },
  },
  Socket: {
    LIGHT: { S: SOCKET, L: SOCKETLong },
    DARK: { S: SOCKET_DARK, L: SOCKET_LONG_DARK },
  },
  Arnica: {
    LIGHT: { S: ARNICA, L: ARNICALong },
    DARK: { S: ARNICA_DARK, L: ARNICA_LONG_DARK },
  },
  Detectify: {
    LIGHT: { S: DETECTIFY, L: DETECTIFYLong },
    DARK: { S: DETECTIFY_DARK, L: DETECTIFY_LONG_DARK },
  },
  GitGuardian: {
    LIGHT: { S: GITGUARDIAN, L: GITGUARDIANLong },
    DARK: { S: GITGUARDIAN_DARK, L: GITGUARDIAN_LONG_DARK },
  },
  "Fortra VM": {
    LIGHT: { S: FORTRAVM, L: FORTRAVMLong },
    DARK: { S: FORTRAVM_DARK, L: FORTRAVM_LONG_DARK },
  },
  "Entra ID": {
    LIGHT: { S: ENTRAID, L: ENTRAIDLong },
    DARK: { S: MICROSOFT_ENTRA_ID_DARK, L: MICROSOFT_ENTRA_ID_LONG_DARK },
  },
  "Active Directory": {
    LIGHT: { S: ACTIVE_DIRECTORY, L: ACTIVE_DIRECTORYLong },
    DARK: { S: ACTIVE_DIRECTORY_DARK, L: ACTIVE_DIRECTORY_LONG_DARK },
  },
  "Salt Security": {
    LIGHT: { S: SALTSECURITY, L: SALTSECURITYLong },
    DARK: { S: SALTSECURITY_DARK, L: SALTSECURITY_LONG_DARK },
  },
  LayerX: {
    LIGHT: { S: LAYERX, L: LAYERXLong },
    DARK: { S: LAYERX_DARK, L: LAYERX_LONG_DARK },
  },
  "Zscaler ZIA": {
    LIGHT: { S: ZSCALER, L: ZSCALERLong },
    DARK: { S: ZSCALER_DARK, L: ZSCALER_LONG_DARK },
  },
  "Microsoft Entra ID": {
    LIGHT: { S: MICROSOFT_ENTRA_ID, L: MICROSOFT_ENTRA_IDLong },
    DARK: { S: MICROSOFT_ENTRA_ID_DARK, L: MICROSOFT_ENTRA_ID_LONG_DARK },
  },
  "Jira Assets": {
    LIGHT: { S: JIRA, L: JIRALong },
    DARK: { S: JIRA_DARK, L: JIRA_LONG_DARK },
  },
  "Grip Security": {
    LIGHT: { S: GRIP, L: GRIPLong },
    DARK: { S: GRIP_DARK, L: GRIP_LONG_DARK },
  },
  NowSecure: {
    LIGHT: { S: NOW_SECURE, L: NOW_SECURELong },
    DARK: { S: NOW_SECURE_DARK, L: NOW_SECURE_LONG_DARK },
  },
  Synack: {
    LIGHT: { S: SYNACK, L: SYNACKLong },
    DARK: { S: SYNACK_DARK, L: SYNACK_LONG_DARK },
  },
  "Bright Security": {
    LIGHT: { S: BRIGHTSECURITY, L: BRIGHTSECURITYLong },
    DARK: { S: BRIGHT_SECURITY_DARK, L: BRIGHT_SECURITY_LONG_DARK },
  },
  "Kodem Security": {
    LIGHT: { S: KODEMSECURITY, L: KODEMSECURITYLong },
    DARK: { S: KODEMSECURITY_DARK, L: KODEMSECURITY_LONG_DARK },
  },
  Astrix: {
    LIGHT: { S: ASTRIX, L: ASTRIXLong },
    DARK: { S: ASTRIX_DARK, L: ASTRIX_LONG_DARK },
  },
  "Bishop Fox": {
    LIGHT: { S: BISHOPFOX, L: BISHOPFOXLong },
    DARK: { S: BISHOPFOX_DARK, L: BISHOPFOX_LONG_DARK },
  },
  Cycode: {
    LIGHT: { S: CYCODE, L: CYCODELong },
    DARK: { S: CYCODE_DARK, L: CYCODE_LONG_DARK },
  },
  CyCognito: {
    LIGHT: { S: CYCOGNITO, L: CYCOGNITOLong },
    DARK: { S: CYCOGNITO_DARK, L: CYCOGNITO_LONG_DARK },
  },
  "Datadog CNAPP": {
    LIGHT: { S: DATADOG, L: DATADOGLong },
    DARK: { S: DATADOG_DARK, L: DATADOG_LONG_DARK },
  },
  Datadog: {
    LIGHT: { S: DATADOG, L: DATADOGLong },
    DARK: { S: DATADOG_DARK, L: DATADOG_LONG_DARK },
  },
  "Entro Security": {
    LIGHT: { S: ENTROSECURITY, L: ENTROSECURITYLong },
    DARK: { S: ENTRO_SECURITY_DARK, L: ENTRO_SECURITY_LONG_DARK },
  },
  Entro: {
    LIGHT: { S: ENTROSECURITY, L: ENTROSECURITYLong },
    DARK: { S: ENTRO_SECURITY_DARK, L: ENTRO_SECURITY_LONG_DARK },
  },
  "Omnissa Workspace ONE UEM": {
    LIGHT: { S: OMNISSA, L: OMNISSALong },
    DARK: { S: OMNISSA_DARK, L: OMNISSA_LONG_DARK },
  },
  AppCheck: { LIGHT: { S: APPCHECK, L: APPCHECKLong }, DARK: null },
  Appknox: {
    LIGHT: { S: APPKNOX, L: APPKNOXLong },
    DARK: { S: APPKNOX_DARK, L: APPKNOX_LONG_DARK },
  },
  BluBracket: { LIGHT: { S: BLUBRACKET, L: BLUBRACKETLong }, DARK: null },
  "Jit Security": {
    LIGHT: { S: JIT, L: JITLong },
    DARK: { S: JIT_DARK, L: JIT_LONG_DARK },
  },
  Seeker: {
    LIGHT: { S: BLACKDUCK, L: BLACKDUCKLong },
    DARK: { S: BLACKDUCK_DARK, L: BLACKDUCK_LONG_DARK },
  },
  "Synopsys Seeker": {
    LIGHT: { S: BLACKDUCK, L: BLACKDUCKLong },
    DARK: { S: BLACKDUCK_DARK, L: BLACKDUCK_LONG_DARK },
  },
  Coverity: {
    LIGHT: { S: COVERITY, L: COVERITYLong },
    DARK: { S: COVERITY_DARK, L: COVERITY_LONG_DARK },
  },
  Onapsis: {
    LIGHT: { S: ONAPSIS, L: ONAPSISLong },
    DARK: { S: ONAPSIS_DARK, L: ONAPSIS_LONG_DARK },
  },
  Oomnitza: {
    LIGHT: { S: OOMNITZA, L: OOMNITZALong },
    DARK: { S: OOMNITZA_DARK, L: OOMNITZA_LONG_DARK },
  },
  Edgescan: {
    LIGHT: { S: EDGESCAN, L: EDGESCANLong },
    DARK: { S: EDGESCAN_DARK, L: EDGESCAN_LONG_DARK },
  },
  Knowbe4: {
    LIGHT: { S: KNOWBE4, L: KNOWBE4Long },
    DARK: { S: KNOWBE4_DARK, L: KNOWBE4_LONG_DARK },
  },
  "Cobalt.io": {
    LIGHT: { S: COBALTIO, L: COBALTIOLong },
    DARK: { S: COBALT_IO_DARK, L: COBALT_IO_LONG_DARK },
  },
  "Project Discovery": {
    LIGHT: { S: PROJECT_DISCOVERY, L: PROJECT_DISCOVERYLong },
    DARK: { S: PROJECT_DISCOVERY_DARK, L: PROJECT_DISCOVERY_LONG_DARK },
  },
  "Palo Alto IOT": {
    LIGHT: { S: PALOALTOIOT, L: PALOALTOIOTLong },
    DARK: { S: PALOALTOIOT_DARK, L: PALOALTOIOT_LONG_DARK },
  },
  "Palo Alto Cortex Cloud": {
    LIGHT: { S: CORTEX_CLOUD, L: CORTEX_CLOUDLong },
    DARK: { S: CORTEX_CLOUD_DARK, L: CORTEX_CLOUD_LONG_DARK },
  },
  "Palo Alto Cortex XDR": {
    LIGHT: { S: CORTEX_XDR, L: CORTEX_XDRLong },
    DARK: { S: CORTEX_XDR_DARK, L: CORTEX_XDR_LONG_DARK },
  },
  "Obsidian Security": {
    LIGHT: { S: OBSIDIAN, L: OBSIDIANLong },
    DARK: { S: OBSIDIAN_DARK, L: OBSIDIAN_LONG_DARK },
  },
  "Microsoft Defender EASM": {
    LIGHT: { S: DEFENDER_EASM, L: DEFENDER_EASMLong },
    DARK: { S: DEFENDER_EASM_DARK, L: DEFENDER_EASM_LONG_DARK },
  },
  Shodan: { LIGHT: { S: SHODAN, L: SHODANLong }, DARK: null },
  ThreatConnect: {
    LIGHT: { S: THREATCONNECT, L: THREATCONNECTLong },
    DARK: { S: THREATCONNECT_DARK, L: THREATCONNECT_LONG_DARK },
  },
  "Threat Modeler": {
    LIGHT: { S: THREATMODELER, L: THREATMODELERLong },
    DARK: { S: THREATMODELER_DARK, L: THREATMODELER_LONG_DARK },
  },
  "OX Security": {
    LIGHT: { S: OXSECURITY, L: OXSECURITYLong },
    DARK: { S: OXSECURITY_DARK, L: OXSECURITY_LONG_DARK },
  },
  Traceable: {
    LIGHT: { S: TRACEABLE, L: TRACEABLELong },
    DARK: { S: TRACEABLE_DARK, L: TRACEABLE_LONG_DARK },
  },
  FleetDM: {
    LIGHT: { S: FLEET, L: FLEETLong },
    DARK: { S: FLEETDM_DARK, L: FLEETDM_LONG_DARK },
  },
  "GitHub Dependabot": {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },

  "Crowdstrike Falcon Surface": {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  "Crowdstrike EASM": {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  "Crowdstrike Cloud Security": {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  "Crowdstrike Falcon Shield": {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  "Falcon Surface": {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  "Github Code Scanning": {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  "GitHub Enterprise": {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  Gem: {
    LIGHT: { S: GEM, L: GEMLong },
    DARK: { S: GEM_DARK, L: GEM_LONG_DARK },
  },
  TruffleHog: {
    LIGHT: { S: TRUFFELHOG, L: TRUFFELHOGLong },
    DARK: { S: TRUFFLEHOG_DARK, L: TRUFFLEHOG_LONG_DARK },
  },
  Trufflehog: {
    LIGHT: { S: TRUFFELHOG, L: TRUFFELHOGLong },
    DARK: { S: TRUFFLEHOG_DARK, L: TRUFFLEHOG_LONG_DARK },
  },
  Semgrep: {
    LIGHT: { S: SEMGREP, L: SEMGREPLong },
    DARK: { S: SEMGREP_DARK, L: SEMGREP_LONG_DARK },
  },
  "Semgrep Commercial": {
    LIGHT: { S: SEMGREP, L: SEMGREPLong },
    DARK: { S: SEMGREP_DARK, L: SEMGREP_LONG_DARK },
  },
  "Data Theorem": {
    LIGHT: { S: DATATHEOREM, L: DATATHEOREMLong },
    DARK: { S: DATATHEOREM_DARK, L: DATATHEOREM_LONG_DARK },
  },
  Orca: {
    LIGHT: { S: ORCA, L: ORCALong },
    DARK: { S: ORCA_DARK, L: ORCA_LONG_DARK },
  },
  OpsLevel: {
    LIGHT: { S: OPSLEVEL, L: OPSLEVELLong },
    DARK: { S: OPSLEVEL_DARK, L: OPSLEVEL_LONG_DARK },
  },
  Snyk: {
    LIGHT: { S: SNYK, L: SNYKLong },
    DARK: { S: SNYK_DARK, L: SNYK_LONG_DARK },
  },
  "GCP Security Command Center": {
    LIGHT: { S: GCP, L: GCPLong },
    DARK: { S: GCP_DARK, L: GCP_LONG_DARK },
  },
  GCP_SecurityCommandCenter: {
    LIGHT: { S: GCP, L: GCPLong },
    DARK: { S: GCP_DARK, L: GCP_LONG_DARK },
  },
  "AWS Security Hub": {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  "AWS Inspector": {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  "AWS-Inspector": {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  "AWS Inventory": {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  "XM Cyber": {
    LIGHT: { S: XMCYBER, L: XMCYBERLong },
    DARK: { S: XMCYBER_DARK, L: XMCYBER_LONG_DARK },
  },
  Axonius: {
    LIGHT: { S: AXONIUS, L: AXONIUSLong },
    DARK: { S: AXONIUS_DARK, L: AXONIUS_LONG_DARK },
  },
  "Google Workspace Alert Center": {
    LIGHT: { S: WORKSPACE, L: WORKSPACELong },
    DARK: { S: WORKSPACE_DARK, L: WORKSPACE_LONG_DARK },
  },
  "Microsoft Defender for Cloud": {
    LIGHT: { S: CLOUDDEFENDER, L: CLOUDDEFENDERLong },
    DARK: { S: CLOUDDEFENDER_DARK, L: CLOUDDEFENDER_LONG_DARK },
  },
  Gytpol: {
    LIGHT: { S: GYTPOL, L: GYTPOLLong },
    DARK: { S: GYTPOL_DARK, L: GYTPOL_LONG_DARK },
  },
  Cyera: {
    LIGHT: { S: CYERA, L: CYERALong },
    DARK: { S: CYERA_DARK, L: CYERA_LONG_DARK },
  },
  "Claroty xDome": {
    LIGHT: { S: CLAROTY, L: CLAROTYLong },
    DARK: { S: CLAROTY_DARK, L: CLAROTY_LONG_DARK },
  },
  "Claroty CTD": {
    LIGHT: { S: CLAROTY, L: CLAROTYLong },
    DARK: { S: CLAROTY_DARK, L: CLAROTY_LONG_DARK },
  },
  Clover: {
    LIGHT: { S: CLOVER, L: CLOVERLong },
    DARK: { S: CLOVER_DARK, L: CLOVER_LONG_DARK },
  },
  "Endor Labs": {
    LIGHT: { S: ENDORLABS, L: ENDORLABSLong },
    DARK: { S: ENDORLABS_DARK, L: ENDORLABS_LONG_DARK },
  },
  "Prisma Cloud": {
    LIGHT: { S: PRISMA, L: PRISMALong },
    DARK: { S: PRISMA_DARK, L: PRISMA_LONG_DARK },
  },
  "Prisma Code": {
    LIGHT: { S: PRISMA, L: PRISMALong },
    DARK: { S: PRISMA_DARK, L: PRISMA_LONG_DARK },
  },
  "Prisma Cloud CWPP": {
    LIGHT: { S: PRISMA, L: PRISMALong },
    DARK: { S: PRISMA_DARK, L: PRISMA_LONG_DARK },
  },
  "Coverity on Polaris": {
    LIGHT: { S: BLACKDUCK, L: BLACKDUCKLong },
    DARK: { S: BLACKDUCK_DARK, L: BLACKDUCK_LONG_DARK },
  },
  Wiz: {
    LIGHT: { S: WIZ, L: WIZLong },
    DARK: { S: WIZ_DARK, L: WIZ_LONG_DARK },
  },
  "Wiz Vulnerabilities": {
    LIGHT: { S: WIZ, L: WIZLong },
    DARK: { S: WIZ_DARK, L: WIZ_LONG_DARK },
  },
  Workday: {
    LIGHT: { S: WORKDAY, L: WORKDAYLong },
    DARK: { S: WORKDAY_DARK, L: WORKDAY_LONG_DARK },
  },
  "Check Point CloudGuard (Dome9)": {
    LIGHT: { S: DOME9, L: DOME9Long },
    DARK: { S: DOME9_DARK, L: DOME9_LONG_DARK },
  },
  Checkmarx: {
    LIGHT: { S: CHECKMARX, L: CHECKMARXLong },
    DARK: { S: CHECKMARX_SAST_DARK, L: CHECKMARX_SAST_LONG_DARK },
  },
  "Checkmarx SAST": {
    LIGHT: { S: CHECKMARX, L: CHECKMARXLong },
    DARK: { S: CHECKMARX_SAST_DARK, L: CHECKMARX_SAST_LONG_DARK },
  },
  "Checkmarx GO": {
    LIGHT: { S: CHECKMARX, L: CHECKMARXLong },
    DARK: { S: CHECKMARX_GO_DARK, L: CHECKMARX_GO_LONG_DARK },
  },
  "Checkmarx Go": {
    LIGHT: { S: CHECKMARX, L: CHECKMARXLong },
    DARK: { S: CHECKMARX_GO_DARK, L: CHECKMARX_GO_LONG_DARK },
  },
  "Checkmarx AST": {
    LIGHT: { S: CHECKMARX, L: CHECKMARXLong },
    DARK: { S: CHECKMARX_AST_DARK, L: CHECKMARX_AST_DARK },
  },
  "Aqua Cloudsploit": {
    LIGHT: { S: AQUA, L: AQUALong },
    DARK: { S: AQUA_DARK, L: AQUA_LONG_DARK },
  },
  "Aqua CWPP": {
    LIGHT: { S: AQUA, L: AQUALong },
    DARK: { S: AQUA_DARK, L: AQUA_LONG_DARK },
  },
  Aqua: {
    LIGHT: { S: AQUA, L: AQUALong },
    DARK: { S: AQUA_DARK, L: AQUA_LONG_DARK },
  },
  Rapid7: {
    LIGHT: { S: RAPID7, L: RAPID7Long },
    DARK: { S: RAPID7_DARK, L: RAPID7_LONG_DARK },
  },
  "Rapid7 CloudVM": {
    LIGHT: { S: RAPID7, L: RAPID7Long },
    DARK: { S: RAPID7_DARK, L: RAPID7_LONG_DARK },
  },
  "Rapid7 Metasploit": {
    LIGHT: { S: RAPID7, L: RAPID7Long },
    DARK: { S: RAPID7_DARK, L: RAPID7_LONG_DARK },
  },
  "Rapid7 Application Security": {
    LIGHT: { S: RAPID7, L: RAPID7Long },
    DARK: { S: RAPID7_DARK, L: RAPID7_LONG_DARK },
  },
  Reco: {
    LIGHT: { S: RECO, L: RECOLong },
    DARK: { S: RECO_DARK, L: RECO_LONG_DARK },
  },
  "Recorded Future": {
    LIGHT: { S: RECORDEDFUTURE, L: RECORDEDFUTURELong },
    DARK: { S: RECORDEDFUTURE_DARK, L: RECORDEDFUTURE_LONG_DARK },
  },
  "Burp Suite": {
    LIGHT: { S: BURPSUITE, L: BURPSUITELong },
    DARK: { S: BURPSUITE_DARK, L: BURPSUITE_LONG_DARK },
  },
  "Cortex.io": {
    LIGHT: { S: CORTEX, L: CORTEXLong },
    DARK: { S: CORTEX_IO_DARK, L: CORTEX_IO_LONG_DARK },
  },
  Cortex: {
    LIGHT: { S: CORTEX, L: CORTEXLong },
    DARK: { S: CORTEX_IO_DARK, L: CORTEX_IO_LONG_DARK },
  },
  CortexXpanse: {
    LIGHT: { S: CORTEXXPANSE, L: CORTEXXPANSELong },
    DARK: { S: CORTEXXPANSE_DARK, L: CORTEXXPANSE_LONG_DARK },
  },
  "Lacework FortiCNAPP": {
    LIGHT: { S: LACEWORK, L: LACEWORKLong },
    DARK: { S: LACEWORK_DARK, L: LACEWORK_LONG_DARK },
  },
  Miggo: {
    LIGHT: { S: MIGGO, L: MIGGO_LONG },
    DARK: { S: MIGGO_DARK, L: MIGGO_LONG_DARK },
  },
  Oligo: {
    LIGHT: { S: OLIGO, L: OLIGOLong },
    DARK: { S: OLIGO_DARK, L: OLIGO_LONG_DARK },
  },
  Oasis: {
    LIGHT: { S: OASIS, L: OASISLong },
    DARK: { S: OASIS_DARK, L: OASIS_LONG_DARK },
  },
  "ServiceNow CMDB": {
    LIGHT: { S: SERVICENOW_CMDB, L: SERVICENOW_CMDBLong },
    DARK: { S: SERVICENOW_CMDB_DARK, L: SERVICENOW_CMDB_LONG_DARK },
  },
  "ServiceNow CMDB Apigee": {
    LIGHT: { S: SERVICENOW_CMDB, L: SERVICENOW_CMDBLong },
    DARK: { S: SERVICENOW_CMDB_DARK, L: SERVICENOW_CMDB_LONG_DARK },
  },
  Qualys: {
    LIGHT: { S: QUALYS, L: QUALYSLong },
    DARK: { S: QUALYS_DARK, L: QUALYS_LONG_DARK },
  },
  "Qualys Container Security": {
    LIGHT: { S: QUALYS, L: QUALYSLong },
    DARK: { S: QUALYS_DARK, L: QUALYS_LONG_DARK },
  },
  "Qualys External Attack Surface Management": {
    LIGHT: { S: QUALYS, L: QUALYSLong },
    DARK: { S: QUALYS_DARK, L: QUALYS_LONG_DARK },
  },
  "Qualys EASM": {
    LIGHT: { S: QUALYS, L: QUALYSLong },
    DARK: { S: QUALYS_DARK, L: QUALYS_LONG_DARK },
  },
  "Qualys Web Application Scanning": {
    LIGHT: { S: QUALYS, L: QUALYSLong },
    DARK: { S: QUALYS_DARK, L: QUALYS_LONG_DARK },
  },
  SafeBreach: {
    LIGHT: { S: SFB, L: SFBLong },
    DARK: { S: SFB_DARK, L: SFB_LONG_DARK },
  },
  Safebreach: {
    LIGHT: { S: SFB, L: SFBLong },
    DARK: { S: SFB_DARK, L: SFB_LONG_DARK },
  },

  SARIF: {
    LIGHT: { S: SARIF, L: SARIFLong },
    DARK: { S: SARIF_DARK, L: SARIF_LONG_DARK },
  },

  "Microsoft Defender for Endpoint": {
    LIGHT: { S: DEFENDER, L: DEFENDERLong },
    DARK: { S: DEFENDER_DARK, L: DEFENDER_LONG_DARK },
  },
  Datacenter: {
    LIGHT: { S: Datacenter, L: DATACENTERLong },
    DARK: { S: Datacenter, L: DATACENTERLong },
  },
  Ermetic: {
    LIGHT: { S: ERMETIC, L: ERMETICLong },
    DARK: { S: ERMETIC_DARK, L: ERMETIC_LONG_DARK },
  },
  Armis: {
    LIGHT: { S: ARMS, L: ARMSLong },
    DARK: { S: ARMS_DARK, L: ARMS_LONG_DARK },
  },
  "Arctic Wolf": {
    LIGHT: { S: ARCTIC_WOLF, L: ARCTIC_WOLFLong },
    DARK: { S: ARCTIC_WOLF_DARK, L: ARCTIC_WOLF_LONG_DARK },
  },
  "Dependency Track": {
    LIGHT: { S: DEPENDENCYTRACK, L: DEPENDENCYTRACKLong },
    DARK: { S: DEPENDENCYTRACK_DARK, L: DEPENDENCYTRACK_LONG_DARK },
  },
  DepthFirst: {
    LIGHT: { S: DEPTHFIRST, L: DEPTHFIRSTLong },
    DARK: { S: DEPTHFIRST_DARK, L: DEPTHFIRST_LONG_DARK },
  },
  Tanium: {
    LIGHT: { S: TANIUM, L: TANIUMLong },
    DARK: { S: TANIUM_DARK, L: TANIUM_LONG_DARK },
  },

  "Tenable.io": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable Vulnerability Management": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable.SC": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable Security Center": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable SC": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Sysdig Secure": {
    LIGHT: { S: SYSDIG, L: SYSDIGLong },
    DARK: { S: SYSDIG_DARK, L: SYSDIG_LONG_DARK },
  },
  "Tenable Web App Scanning": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable SC On Prem": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable Security Center On Prem": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  Tenable: {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable Nessus Professional": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },

  Whitesource: {
    LIGHT: { S: WSO, L: WSOLong },
    DARK: { S: WHITESOURCE_DARK, L: WHITESOURCE_LONG_DARK },
  },
  Inspector: {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  "AWS-SecurityHub": {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  Hacker1: {
    LIGHT: { S: HACKER1, L: HACKER1Long },
    DARK: { S: HACKER1_DARK, L: HACKER1_LONG_DARK },
  },
  Fixinator: {
    LIGHT: { S: FIXINATOR, L: FIXINATORLong },
    DARK: { S: FIXINATOR_DARK, L: FIXINATOR_LONG_DARK },
  },
  Fossa: {
    LIGHT: { S: FOSSA, L: FOSSALong },
    DARK: { S: FOSSA_DARK, L: FOSSA_LONG_DARK },
  },
  "Adaptive Shield": {
    LIGHT: { S: ADAPTIVESHIELD, L: ADAPTIVESHIELDLong },
    DARK: { S: ADAPTIVE_SHIELD_DARK, L: ADAPTIVE_SHIELD_LONG_DARK },
  },
  Crowdstrike: {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  "Crowdstrike Threat Intelligence": {
    LIGHT: { S: CROWDSTRIKE, L: CROWDSTRIKELong },
    DARK: { S: CROWDSTRIKE_DARK, L: CROWDSTRIKE_LONG_DARK },
  },
  Intruder: {
    LIGHT: { S: INTRUDER, L: INTRUDERLong },
    DARK: { S: INTRUDER_DARK, L: INTRUDER_LONG_DARK },
  },
  "Prisma Code Security (Cider)": {
    LIGHT: { S: CIDER, L: CIDERLong },
    DARK: { S: CIDER_DARK, L: CIDER_LONG_DARK },
  },
  Cider: {
    LIGHT: { S: CIDER, L: CIDERLong },
    DARK: { S: CIDER_DARK, L: CIDER_LONG_DARK },
  },
  Okta: {
    LIGHT: { S: OKTA, L: OKTALong },
    DARK: { S: OKTA_DARK, L: OKTA_LONG_DARK },
  },
  "SentinelOne - Singularity": {
    LIGHT: { S: SENTINELONE, L: SENTINELONELong },
    DARK: { S: SENTINELONE_DARK, L: SENTINELONE_LONG_DARK },
  },
  Sentinel1: {
    LIGHT: { S: SENTINELONE, L: SENTINELONELong },
    DARK: { S: SENTINELONE_DARK, L: SENTINELONE_LONG_DARK },
  },
  "WhiteHat Sentinel": {
    LIGHT: { S: WHITEHAT, L: WHITEHATLong },
    DARK: { S: WHITEHAT_DARK, L: WHITEHAT_LONG_DARK },
  },
  WhiteHat: {
    LIGHT: { S: WHITEHAT, L: WHITEHATLong },
    DARK: { S: WHITEHAT_DARK, L: WHITEHAT_LONG_DARK },
  },
  Bugcrowd: {
    LIGHT: { S: BUGCROWD, L: BUGCROWDLong },
    DARK: { S: BUGCROWD_DARK, L: BUGCROWD_LONG_DARK },
  },
  Fortify: {
    LIGHT: { S: FORTIFY, L: FORTIFYLong },
    DARK: { S: FORTIFY_DARK, L: FORTIFY_LONG_DARK },
  },
  FortifyData: {
    LIGHT: { S: FORTIFYDATA, L: FORTIFYDATALong },
    DARK: { S: FORTIFYDATA_DARK, L: FORTIFYDATA_LONG_DARK },
  },
  Flexera: {
    LIGHT: { S: FLEXERA, L: FLEXERALong },
    DARK: { S: FLEXERA_DARK, L: FLEXERA_LONG_DARK },
  },
  SonarQube: {
    LIGHT: { S: SONARQUBE, L: SONARQUBELong },
    DARK: { S: SONARQUBE_DARK, L: SONARQUBE_LONG_DARK },
  },
  Veracode: {
    LIGHT: { S: VERACODE, L: VERACODELong },
    DARK: { S: VERACODE_DARK, L: VERACODE_LONG_DARK },
  },
  Vicarius: {
    LIGHT: { S: VICARIUS, L: VICARIUSLong },
    DARK: { S: VICARIUS_DARK, L: VICARIUS_LONG_DARK },
  },
  "Black Duck": {
    LIGHT: { S: BLACKDUCK, L: BLACKDUCKLong },
    DARK: { S: BLACKDUCK_DARK, L: BLACKDUCK_LONG_DARK },
  },
  "Black Duck Polaris": {
    LIGHT: { S: BLACKDUCK, L: BLACKDUCKLong },
    DARK: { S: BLACKDUCK_DARK, L: BLACKDUCK_LONG_DARK },
  },
  "Black Duck Binary Analysis": {
    LIGHT: { S: BLACKDUCK, L: BLACKDUCKLong },
    DARK: { S: BLACKDUCK_DARK, L: BLACKDUCK_LONG_DARK },
  },
  BigFix: {
    LIGHT: { S: BIGFIX, L: BIGFIXLong },
    DARK: { S: BIGFIX_DARK, L: BIGFIX_LONG_DARK },
  },
  GitLab: {
    LIGHT: { S: GITLAB_SCA, L: GITLAB_SCALong },
    DARK: { S: GITLAB_DARK, L: GITLAB_LONG_DARK },
  },
  Gitlab: {
    LIGHT: { S: GITLAB_SCA, L: GITLAB_SCALong },
    DARK: { S: GITLAB_DARK, L: GITLAB_LONG_DARK },
  },
  Acunetix: {
    LIGHT: { S: ACUNETIX, L: ACUNETIXLong },
    DARK: { S: ACUNETIX_DARK, L: ACUNETIX_LONG_DARK },
  },
  "JFrog Xray": {
    LIGHT: { S: JFROGXRAY, L: JFROGXRAYLong },
    DARK: { S: JFROGXRAY_DARK, L: JFROGXRAY_LONG_DARK },
  },
  "JFrog VDOO Vision": {
    LIGHT: { S: JFROG, L: JFROGLong },
    DARK: { S: JFROG_DARK, L: JFROG_LONG_DARK },
  },
  Mend: {
    LIGHT: { S: MEND, L: MENDLong },
    DARK: { S: MEND_DARK, L: MEND_LONG_DARK },
  },
  Nautobot: {
    LIGHT: { S: NAUTOBOT, L: NAUTOBOTLong },
    DARK: { S: NAUTOBOT_DARK, L: NAUTOBOT_LONG_DARK },
  },
  Netskope: {
    LIGHT: { S: NETSKOPE, L: NETSKOPELong },
    DARK: { S: NETSKOPE_DARK, L: NETSKOPE_LONG_DARK },
  },
  Trivy: {
    LIGHT: { S: TRIVY, L: TRIVYLong },
    DARK: { S: TRIVY_DARK, L: TRIVY_LONG_DARK },
  },
  SonaType: {
    LIGHT: { S: SONATYPE, L: SONATYPELong },
    DARK: { S: SONATYPE_DARK, L: SONATYPE_LONG_DARK },
  },
  Sonatype: {
    LIGHT: { S: SONATYPE, L: SONATYPELong },
    DARK: { S: SONATYPE_DARK, L: SONATYPE_LONG_DARK },
  },
  Sentra: {
    LIGHT: { S: SENTRA, L: SENTRALong },
    DARK: { S: SENTRA_DARK, L: SENTRA_LONG_DARK },
  },
  Netsparker: {
    LIGHT: { S: NTSPRKR, L: NTSPRKRLong },
    DARK: { S: NETSPARKER_DARK, L: NETSPARKER_LONG_DARK },
  },
  Uptycs: {
    LIGHT: { S: UPTYCS, L: UPTYCSLong },
    DARK: { S: UPTYCS_DARK, L: UPTYCS_LONG_DARK },
  },
  Sonrai: {
    LIGHT: { S: SONRAI, L: SONRAILong },
    DARK: { S: SONRAI_DARK, L: SONRAI_LONG_DARK },
  },
  "Tenable.CS": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  "Tenable Cloud Security": {
    LIGHT: { S: TEN, L: TENLong },
    DARK: { S: TEN_DARK, L: TEN_LONG_DARK },
  },
  Apiiro: {
    LIGHT: { S: APIIRO, L: APIIROLong },
    DARK: { S: APIIRO_DARK, L: APIIRO_LONG_DARK },
  },
  Mandiant: {
    LIGHT: { S: MANDIANT, L: MANDIANTLong },
    DARK: { S: MANDIANT_DARK, L: MANDIANT_LONG_DARK },
  },
  "Mandiant Attack Surface": {
    LIGHT: { S: MANDIANT, L: MANDIANTLong },
    DARK: { S: MANDIANT_DARK, L: MANDIANT_LONG_DARK },
  },
  "Mandiant Threat Intelligence": {
    LIGHT: { S: MANDIANT, L: MANDIANTLong },
    DARK: { S: MANDIANT_DARK, L: MANDIANT_LONG_DARK },
  },
  NetSpyGlass: {
    LIGHT: { S: NETSPYGLASS, L: NETSPYGLASSLong },
    DARK: { S: NETSPYGLASS_DARK, L: NETSPYGLASS_LONG_DARK },
  },
  Noname: {
    LIGHT: { S: NONAME, L: NONAMELong },
    DARK: { S: NONAME_DARK, L: NONAME_LONG_DARK },
  },
  "Noma Security": {
    LIGHT: { S: NOMASECURITY, L: NOMASECURITY_LONG },
    DARK: { S: NOMASECURITY_DARK, L: NOMASECURITY_LONG_DARK },
  },
  // Saml - Temporary
  GOOGLE: { LIGHT: { S: GOOGLE, L: GOOGLE }, DARK: { S: GOOGLE, L: GOOGLE } },
  AUTH0: { LIGHT: { S: AUTH0, L: AUTH0 }, DARK: null },
  // Ticketing -Temporary
  SEEMPLICITY: {
    LIGHT: { S: SEEMPLICITY, L: SEEMPLICITYLong },
    DARK: { S: SEEMPLICITY_DARK, L: SEEMPLICITY_LONG_DARK },
  },
  SecurityScoreCard: {
    LIGHT: { S: SECURITYSCORECARD, L: SECURITYSCORECARDLong },
    DARK: { S: SECURITYSCORECARD_DARK, L: SECURITYSCORECARD_LONG_DARK },
  },
  MS_TEAMS: {
    LIGHT: { S: MSTEAMS, L: MSTEAMSLong },
    DARK: { S: MSTEAMS, L: MSTEAMSLong },
  },
  BMC_HELIX: {
    LIGHT: { S: BMCHELIX, L: BMCHELIXLong },
    DARK: { S: BMCHELIX_DARK, L: BMCHELIX_LONG_DARK },
  },
  SLACK: {
    LIGHT: { S: SLACK, L: SLACKLong },
    DARK: { S: SLACK_DARK, L: SLACK_LONG_DARK },
  },
  "Splunk Importer": {
    LIGHT: { S: SPLUNKIMPORTER, L: SPLUNKIMPORTERLong },
    DARK: { S: SPLUNKIMPORTER_DARK, L: SPLUNKIMPORTER_LONG_DARK },
  },
  "Stream.Security": {
    LIGHT: { S: STREAMSECURITY, L: STREAMSECURITYLong },
    DARK: { S: STREAMSECURITY_DARK, L: STREAMSECURITY_LONG_DARK },
  },
  "Step Security": {
    LIGHT: { S: STEPSECURITY, L: STEPSECURITYLong },
    DARK: { S: STEPSECURITY_DARK, L: STEPSECURITY_LONG_DARK },
  },
  EMAIL: {
    LIGHT: { S: EMAIL, L: EMAIL },
    DARK: { S: EMAIL_DARK, L: EMAIL_DARK },
  },
  MONDAY: {
    LIGHT: { S: MONDAY, L: MONDAYLong },
    DARK: { S: MONDAY_DARK, L: MONDAY_LONG_DARK },
  },
  SERVICENOW: {
    LIGHT: { S: SERVICENOW, L: SERVICENOWLong },
    DARK: { S: SERVICENOW_DARK, L: SERVICENOW_LONG_DARK },
  },
  IVANTI: {
    LIGHT: { S: IVANTI, L: IVANTILong },
    DARK: { S: IVANTI_DARK, L: IVANTI_LONG_DARK },
  },
  GITHUB_ISSUES: {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  FRESHSERVICE: {
    LIGHT: { S: FRESHSERVICE, L: FRESHSERVICELong },
    DARK: { S: FRESHSERVICE_DARK, L: FRESHSERVICE_LONG_DARK },
  },
  SERVICE_DESK_ON_PREM: {
    LIGHT: { S: SERVICE_DESK_ON_PREM, L: SERVICE_DESK_ON_PREMLong },
    DARK: { S: SERVICE_DESK_ON_PREM_DARK, L: SERVICE_DESK_ON_PREM_LONG_DARK },
  },
  TEAMDYNAMIX: {
    LIGHT: { S: TEAMDYNAMIX, L: TEAMDYNAMIXLong },
    DARK: { S: TEAMDYNAMIX_DARK, L: TEAMDYNAMIX_LONG_DARK },
  },
  ZENDESK: {
    LIGHT: { S: ZENDESK, L: ZENDESKLong },
    DARK: { S: ZENDESK_DARK, L: ZENDESK_LONG_DARK },
  },
  CONNECTWISE: {
    LIGHT: { S: CONNECTWISE, L: CONNECTWISELong },
    DARK: { S: CONNECTWISE_DARK, L: CONNECTWISE_LONG_DARK },
  },
  JIRA: {
    LIGHT: { S: JIRA, L: JIRALong },
    DARK: { S: JIRA_DARK, L: JIRA_LONG_DARK },
  },
  "Jira Issues": {
    LIGHT: { S: JIRA, L: JIRALong },
    DARK: { S: JIRA_DARK, L: JIRA_LONG_DARK },
  },
  Jira: {
    LIGHT: { S: JIRA, L: JIRALong },
    DARK: { S: JIRA_DARK, L: JIRA_LONG_DARK },
  },
  JIRA_ON_PREM: {
    LIGHT: { S: JIRA_ON_PREM, L: JIRA_ON_PREMLong },
    DARK: { S: JIRA_DARK, L: JIRA_LONG_DARK },
  },
  FIBERY: {
    LIGHT: { S: FIBERY, L: FIBERYLong },
    DARK: { S: FIBERY_DARK, L: FIBERY_LONG_DARK },
  },
  AZURE_DEVOPS: {
    LIGHT: { S: AZUREDEVOPS, L: AZUREDEVOPSLong },
    DARK: { S: AZUREDEVOPS_DARK, L: AZUREDEVOPS_LONG_DARK },
  },
  NTTGN: {
    LIGHT: { S: NTTGN, L: NTTGNLong },
    DARK: { S: NTTGN_DARK, L: NTTGN_LONG_DARK },
  },
  // Rap - Temporary
  RAP: { LIGHT: { S: RAP }, DARK: { S: RAP } },
  UNKNOWN: {
    LIGHT: { S: DEFAULT_DATA_SOURCE },
    DARK: { S: DEFAULT_DATA_SOURCE },
  },
  "Oracle Cloud Infrastructure": {
    LIGHT: { S: OCI, L: OCILong },
    DARK: { S: OCI_DARK, L: OCI_LONG_DARK },
  },
  "Zafran Security": {
    LIGHT: { S: ZAFRANSECURITY, L: ZAFRANSECURITYLong },
    DARK: { S: ZAFRAN_SECURITY_DARK, L: ZAFRAN_SECURITY_LONG_DARK },
  },
  // Threat intelligence
  "Cisa KEV Enricher": {
    LIGHT: { S: CISA_KEV, L: CISA_KEVLong },
    DARK: { S: CISA_KEV_DARK, L: CISA_KEV_LONG_DARK },
  },
  "Vulnrichment": {
    LIGHT: { S: CISA_KEV, L: CISA_KEVLong },
    DARK: { S: CISA_KEV_DARK, L: CISA_KEV_LONG_DARK },
  },
  "Epss Enricher": { LIGHT: { S: EPSS, L: EPSSLONG }, DARK: null },
  "VulnCheck KEV Enricher": {
    LIGHT: { S: VULNCHECK_KEV, L: VULNCHECK_KEVLong },
    DARK: { S: VULNCHECK_KEV_DARK, L: VULNCHECK_KEV_LONG_DARK },
  },
  "VulnCheck NVD": {
    LIGHT: { S: VULNCHECK_KEV, L: VULNCHECK_KEVLong },
    DARK: { S: VULNCHECK_KEV_DARK, L: VULNCHECK_KEV_LONG_DARK },
  },
  "NVD Enricher": {
    LIGHT: { S: NVD, L: NVDLong },
    DARK: { S: NVD_DARK, L: NVD_LONG_DARK },
  },
  EUVD: {
    LIGHT: { S: EUVD, L: EUVDLong },
    DARK: { S: EUVD_DARK, L: EUVD_LONG_DARK },
  },
  Inspectiv: {
    LIGHT: { S: INSPECTIV, L: INSPECTIVLong },
    DARK: { S: INSPECTIV_DARK, L: INSPECTIV_LONG_DARK },
  },
  IONIX: {
    LIGHT: { S: IONIX, L: IONIXLong },
    DARK: { S: IONIX_DARK, L: IONIX_LONG_DARK },
  },
  "Invicti Platform": {
    LIGHT: { S: INVICTI, L: INVICTILong },
    DARK: { S: INVICTI_DARK, L: INVICTI_LONG_DARK },
  },
  IRU: {
    LIGHT: { S: IRU, L: IRULong },
    DARK: { S: IRU_DARK, L: IRU_LONG_DARK },
  },
  "Iru (formerly Kandji)": {
    LIGHT: { S: IRU, L: IRULong },
    DARK: { S: IRU_DARK, L: IRU_LONG_DARK },
  },
  Iru: {
    LIGHT: { S: IRU, L: IRULong },
    DARK: { S: IRU_DARK, L: IRU_LONG_DARK },
  },
  "MISP Threat Sharing": { LIGHT: { S: MISP, L: MISPLong }, DARK: null },
  "NetSPI Resolve": {
    LIGHT: { S: NETSPI, L: NETSPILong },
    DARK: { S: NETSPI_DARK, L: NETSPI_LONG_DARK },
  },
  "NetSPI Platform": {
    LIGHT: { S: NETSPI, L: NETSPILong },
    DARK: { S: NETSPI_DARK, L: NETSPI_LONG_DARK },
  },
  "Checkpoint Harmony Endpoint": {
    LIGHT: { S: CHECKPOINTHARMONY, L: CHECKPOINTHARMONYLong },
    DARK: { S: CHECKPINTHARMONY_DARK, L: CHECKPINTHARMONY_LONG_DARK },
  },
  "Checkpoint Workforce AI Security": {
    LIGHT: { S: CHECKPOINT, L: CHECKPOINTLong },
    DARK: { S: CHECKPOINT_DARK, L: CHECKPOINT_LONG_DARK },
  },
  Upwind: {
    LIGHT: { S: UPWIND, L: UPWINDLong },
    DARK: { S: UPWIND_DARK, L: UPWIND_LONG_DARK },
  },
  Harbor: {
    LIGHT: { S: HARBOR, L: HARBORLong },
    DARK: { S: HARBOR_DARK, L: HARBOR_LONG_DARK },
  },
  "Google Threat Intelligence": {
    LIGHT: { S: GOOGLE_THREAT_INTEL, L: GOOGLE_THREAT_INTELLong },
    DARK: null,
  },
  "Trend Vision One": {
    LIGHT: { S: TRENDMICRO, L: TRENDMICROLong },
    DARK: { S: TREND_MICRO_DARK, L: TREND_MICRO_LONG_DARK },
  },
  "Elastic Search": {
    LIGHT: { S: ELASTICCLOUDSECURITY, L: ELASTICCLOUDSECURITYLong },
    DARK: { S: ELASTIC_SECURITY_DARK, L: ELASTIC_SECURITY_LONG_DARK },
  },
  "Azure Data Factory OData": {
    LIGHT: { S: AZURE, L: AZURELong },
    DARK: { S: AZURE_DARK, L: AZURE_LONG_DARK },
  },
  "Recorded Future Attack Surface Intelligence": {
    LIGHT: { S: RECORDEDFUTURE, L: RECORDEDFUTURELong },
    DARK: { S: RECORDEDFUTURE_DARK, L: RECORDEDFUTURE_LONG_DARK },
  },
  "Cisco Catalyst Center": {
    LIGHT: { S: CISCO, L: CISCOLong },
    DARK: { S: CISCO_DARK, L: CISCO_LONG_DARK },
  },
  "Azure Resource Manager": {
    LIGHT: { S: AZURERESOURCES, L: AZURERESOURCESLong },
    DARK: { S: AZURERESOURCES, L: AZURERESOURCESLong },
  },
  "Tenable PCI ASV": {
    LIGHT: { S: TENPCI, L: TENPCILong },
    DARK: { S: TENPCI_DARK, L: TENPCI_LONG_DARK },
  },
  "Omnitron CMDB": {
    LIGHT: { S: MICROSOFT, L: MICROSOFTLong },
    DARK: { S: MICROSOFT_DARK, L: MICROSOFT_LONG_DARK },
  },
  Securitron: {
    LIGHT: { S: MICROSOFT, L: MICROSOFTLong },
    DARK: { S: MICROSOFT_DARK, L: MICROSOFT_LONG_DARK },
  },
  "GitHub Advanced Security for Azure DevOps": {
    LIGHT: { S: AZUREDEVOPS, L: AZUREDEVOPSLong },
    DARK: { S: AZUREDEVOPS_DARK, L: AZUREDEVOPS_LONG_DARK },
  },
  "Censys ASM": {
    LIGHT: { S: CENSYS, L: CENSYSLong },
    DARK: { S: CENSYS_DARK, L: CENSYS_LONG_DARK },
  },
  Horizon3: {
    LIGHT: { S: HORIZON3, L: HORIZON3Long },
    DARK: { S: HORIZON3_DARK, L: HORIZON3_LONG_DARK },
  },
  "Horizon3.ai": {
    LIGHT: { S: HORIZON3, L: HORIZON3Long },
    DARK: { S: HORIZON3_DARK, L: HORIZON3_LONG_DARK },
  },
  Hexnode: {
    LIGHT: { S: HEXNODE, L: HEXNODELong },
    DARK: { S: HEXNODE_DARK, L: HEXNODE_LONG_DARK },
  },
  Stackhawk: {
    LIGHT: { S: STACKHAWK, L: STACKHAWKLong },
    DARK: { S: STACKHAWK_DARK, L: STACKHAWK_LONG_DARK },
  },
  Gitleaks: {
    LIGHT: { S: GITLEAKS, L: GITLEAKSLong },
    DARK: { S: GITLEAKS_DARK, L: GITLEAKS_LONG_DARK },
  },
  "Legit Security": {
    LIGHT: { S: LEGIT, L: LEGITLong },
    DARK: { S: LEGIT_DARK, L: LEGIT_LONG_DARK },
  },
  "Anomali Threat Intelligence": {
    LIGHT: { S: ANOMALI_THREAT_INTEL, L: ANOMALI_THREAT_INTELLong },
    DARK: { S: ANOMALI_DARK, L: ANOMALI_LONG_DARK },
  },
  "Escape Security": {
    LIGHT: { S: ESCAPESECURITY, L: ESCAPESECURITYLong },
    DARK: { S: ESCAPESECURITY_DARK, L: ESCAPESECURITY_LONG_DARK },
  },
  Cymulate: {
    LIGHT: { S: CYMULATE, L: CYMULATELong },
    DARK: { S: CYMULATE_DARK, L: CYMULATE_LONG_DARK },
  },
  CWE: {
    LIGHT: { S: CWE, L: CWELong },
    DARK: { S: CWE_DARK, L: CWE_LONG_DARK },
  },
  "ManageEngine UEM": {
    LIGHT: { S: MANAGEENGINE, L: MANAGEENGINELong },
    DARK: { S: MANAGEENGINE_DARK, L: MANAGEENGINE_LONG_DARK },
  },
  "IBM Guardium": {
    LIGHT: { S: GUARDIUM, L: GUARDIUMLong },
    DARK: { S: GUARDIUM_DARK, L: GUARDIUM_DARK },
  },
  "Kenna Security": {
    LIGHT: { S: KENNASECURITY, L: KENNASECURITYLong },
    DARK: null,
  },
  "Checkmarx One": {
    LIGHT: { S: CHECKMARX, L: CHECKMARXLong },
    DARK: { S: CHECKMARX_ONE_DARK, L: CHECKMARX_ONE_LONG_DARK },
  },
  "GitHub Inventory": {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  Bitbucket: {
    LIGHT: { S: BITBUCKET, L: BITBUCKETLong },
    DARK: { S: BITBUCKET_DARK, L: BITBUCKET_LONG_DARK },
  },
  UpGuard: {
    LIGHT: { S: UPGUARD, L: UPGUARDLong },
    DARK: { S: UPGUARD_DARK, L: UPGUARD_LONG_DARK },
  },
  "Microsoft Secure Score": {
    LIGHT: { S: MICROSOFT, L: MICROSOFTLong },
    DARK: { S: MICROSOFT_DARK, L: MICROSOFT_LONG_DARK },
  },
  "Microsoft Intune": {
    LIGHT: { S: MICROSOFT, L: MICROSOFTLong },
    DARK: { S: MICROSOFT_DARK, L: MICROSOFT_LONG_DARK },
  },
  "Doom Broker": {
    LIGHT: { S: MICROSOFT, L: MICROSOFTLong },
    DARK: { S: MICROSOFT_DARK, L: MICROSOFT_LONG_DARK },
  },
  "Imperva SaaS": {
    LIGHT: { S: IMPERVA, L: IMPERVALong },
    DARK: { S: IMPERVA_DARK, L: IMPERVA_LONG_DARK },
  },
  // Basic cloud provider mappings to fix regression from main branch
  aws: {
    LIGHT: { S: AWS, L: AWSLong },
    DARK: { S: AWS_DARK, L: AWS_LONG_DARK },
  },
  gcp: {
    LIGHT: { S: GCP, L: GCPLong },
    DARK: { S: GCP_DARK, L: GCP_LONG_DARK },
  },
  azure: {
    LIGHT: { S: AZURE, L: AZURELong },
    DARK: { S: AZURE_DARK, L: AZURE_LONG_DARK },
  },
  datacenter: {
    LIGHT: { S: Datacenter, L: DATACENTERLong },
    DARK: { S: Datacenter, L: DATACENTERLong },
  },
  // Additional provider mappings for missing icons
  docker_hub: {
    LIGHT: { S: DOCKER, L: DOCKERLong },
    DARK: { S: DOCKER_DARK, L: DOCKER_LONG_DARK },
  },
  manual: {
    LIGHT: { S: Cloud, L: Cloud },
    DARK: { S: Cloud_DARK, L: Cloud_DARK },
  },
  Manual: {
    LIGHT: { S: MAN, L: MANLong },
    DARK: { S: MAN_DARK },
  },
  // Additional commonly used provider mappings to prevent regressions
  external: {
    LIGHT: { S: Cloud, L: Cloud },
    DARK: { S: Cloud_DARK, L: Cloud_DARK },
  },
  github: {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  git_hub: {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  git_lab: {
    LIGHT: { S: GITLAB_SCA, L: GITLAB_SCALong },
    DARK: { S: GITLAB_DARK, L: GITLAB_LONG_DARK },
  },
  gitlab: {
    LIGHT: { S: GITLAB_SCA, L: GITLAB_SCALong },
    DARK: { S: GITLAB_DARK, L: GITLAB_LONG_DARK },
  },
  bitbucket: {
    LIGHT: { S: BITBUCKET, L: BITBUCKETLong },
    DARK: { S: BITBUCKET_DARK, L: BITBUCKET_LONG_DARK },
  },
  bitbucket_cloud: {
    LIGHT: { S: BITBUCKET, L: BITBUCKETLong },
    DARK: { S: BITBUCKET_DARK, L: BITBUCKET_LONG_DARK },
  },
  ecr: {
    LIGHT: { S: ECR, L: ECRLong },
    DARK: { S: AMAZONECR_DARK, L: AMAZONECR_LONG_DARK },
  },
  aws_ecr: {
    LIGHT: { S: ECR, L: ECRLong },
    DARK: { S: AMAZONECR_DARK, L: AMAZONECR_LONG_DARK },
  },
  amazon_ecr: {
    LIGHT: { S: ECR, L: ECRLong },
    DARK: { S: AMAZONECR_DARK, L: AMAZONECR_LONG_DARK },
  },
  acr: {
    LIGHT: { S: ACR, L: ACRLong },
    DARK: null,
  },
  azure_container_registry: {
    LIGHT: { S: ACR, L: ACRLong },
    DARK: null,
  },
  microsoft_container_registry: {
    LIGHT: { S: ACR, L: ACRLong },
    DARK: null,
  },
  teams: {
    LIGHT: { S: MSTEAMS, L: MSTEAMSLong },
    DARK: { S: MSTEAMS, L: MSTEAMSLong },
  },
  box: {
    LIGHT: { S: BOX, L: BOXLong },
    DARK: { S: BOX_DARK, L: BOX_LONG_DARK },
  },
  confluence: {
    LIGHT: { S: CONFLUENCE, L: CONFLUENCELong },
    DARK: { S: CONFLUENCE_DARK, L: CONFLUENCE_LONG_DARK },
  },
  service_now: {
    LIGHT: { S: SERVICENOW, L: SERVICENOWLong },
    DARK: { S: SERVICENOW_DARK, L: SERVICENOW_LONG_DARK },
  },
  kubernetes: {
    LIGHT: { S: KUBERNETES, L: KUBERENETESLong },
    DARK: { S: KUBERNETES_DARK, L: KUBERNETES_LONG_DARK },
  },
  datadog: {
    LIGHT: { S: DATADOG, L: DATADOGLong },
    DARK: { S: DATADOG_DARK, L: DATADOG_LONG_DARK },
  },
  jenkins: {
    LIGHT: { S: JENKINS, L: JENKINSLong },
    DARK: { S: JENKINS_DARK, L: JENKINS_LONG_DARK },
  },
  zscaler: {
    LIGHT: { S: ZSCALER, L: ZSCALERLong },
    DARK: { S: ZSCALER_DARK, L: ZSCALER_LONG_DARK },
  },
  other: {
    LIGHT: { S: CodeRepository, L: CodeRepository },
    DARK: { S: CodeRepository_DARK, L: CodeRepository_DARK },
  },
  code_repository: {
    LIGHT: { S: CodeRepository, L: CodeRepository },
    DARK: { S: CodeRepository_DARK, L: CodeRepository_DARK },
  },
  cross_system: {
    LIGHT: { S: CodeRepository, L: CodeRepository },
    DARK: { S: CodeRepository_DARK, L: CodeRepository_DARK },
  },
  // Complete the remaining missing provider mappings
  asana: {
    LIGHT: { S: ASANA, L: ASANALong },
    DARK: { S: ASANA_DARK, L: ASANA_LONG_DARK },
  },
  atlas: {
    LIGHT: { S: ATLAS, L: ATLASLong },
    DARK: { S: ATLAS_DARK, L: ATLAS_LONG_DARK },
  },
  circleci: {
    LIGHT: { S: CIRCLECI, L: CIRCLECILong },
    DARK: { S: CIRCLECI_DARK, L: CIRCLECI_LONG_DARK },
  },
  desktop_management: {
    LIGHT: { S: MONITOR, L: MONITOR },
    DARK: { S: MONITOR_DARK, L: MONITOR_DARK },
  },
  docu_sign: {
    LIGHT: { S: DOCUSIGN, L: DOCUSIGNLong },
    DARK: { S: DOCUSIGN_DARK, L: DOCUSIGN_LONG_DARK },
  },
  elastic: {
    LIGHT: { S: ELASTICCLOUDSECURITY, L: ELASTICCLOUDSECURITYLong },
    DARK: { S: ELASTIC_SECURITY_DARK, L: ELASTIC_SECURITY_LONG_DARK },
  },
  g_suite: {
    LIGHT: { S: GOOGLEWORKSPACE, L: GOOGLEWORKSPACELong },
    DARK: { S: WORKSPACE_DARK, L: WORKSPACE_LONG_DARK },
  },
  git_hub_container_registry: {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  git_lab_container_registry: {
    LIGHT: { S: GITLAB_SCA, L: GITLAB_SCALong },
    DARK: { S: GITLAB_DARK, L: GITLAB_LONG_DARK },
  },
  github_actions: {
    LIGHT: { S: GITHUBACTIONS, L: GITHUBACTIONSLong },
    DARK: { S: GITHUBACTIONS, L: GITHUBACTIONSLong_DARK },
  },
  github_container_registry: {
    LIGHT: { S: GIT, L: GITLong },
    DARK: { S: GIT_DARK, L: GIT_LONG_DARK },
  },
  google_container_registry: {
    LIGHT: { S: GOOGLECONTAINERREGISTRY, L: GOOGLECONTAINERREGISTRY },
    DARK: null,
  },
  goriv: {
    LIGHT: { S: DEFAULT_DATA_SOURCE, L: DEFAULT_DATA_SOURCE },
    DARK: { S: DEFAULT_DATA_SOURCE, L: DEFAULT_DATA_SOURCE },
  },
  harbor_container_registry: {
    LIGHT: { S: HARBOR, L: HARBORLong },
    DARK: { S: HARBOR_DARK, L: HARBOR_LONG_DARK },
  },
  hashicorp_vault: {
    LIGHT: { S: HASHICORP, L: HASHICORPLong },
    DARK: { S: HASHICORP_DARK, L: HASHICORP_LONG_DARK },
  },
  intune: {
    LIGHT: { S: INTUNE, L: INTUNELong },
    DARK: { S: INTUNE_DARK, L: INTUNE_LONG_DARK },
  },
  j_frog: {
    LIGHT: { S: JFROG, L: JFROGLong },
    DARK: { S: JFROG_DARK, L: JFROG_LONG_DARK },
  },
  j_frog_container_registry: {
    LIGHT: { S: JFROGCONTAINERREGISTRY, L: JFROGCONTAINERREGISTRY },
    DARK: { S: JFROGCONTAINERREGISTRY, L: JFROGCONTAINERREGISTRY },
  },
  kubernetes_container_image_registry: {
    LIGHT: { S: KUBERNETES, L: KUBERENETESLong },
    DARK: { S: KUBERNETES_DARK, L: KUBERNETES_LONG_DARK },
  },
  lucidchart: {
    LIGHT: { S: LUCIDCHART, L: LUCIDCHARTLong },
    DARK: { S: LUCIDCHART_DARK, L: LUCIDCHART_LONG_DARK },
  },
  nexus_container_registry: {
    LIGHT: { S: NEXUS, L: NEXUS },
    DARK: { S: NEXUS_DARK, L: NEXUS_DARK },
  },
  notion: {
    LIGHT: { S: NOTION, L: NOTIONLong },
    DARK: { S: NOTION_DARK, L: NOTION_LONG_DARK },
  },
  pager_duty: {
    LIGHT: { S: PAGERDUTY, L: PAGERDUTYLong },
    DARK: { S: PAGERDUTY_DARK, L: PAGERDUTY_LONG_DARK },
  },
  red_hat_container_registry: {
    LIGHT: { S: REDHAT, L: REDHAT_LONG },
    DARK: { S: REDHAT_DARK, L: REDHAT_LONG_DARK },
  },
  salesforce: {
    LIGHT: { S: SALESFORCE, L: SALESFORCELong },
    DARK: { S: SALESFORCE, L: SALESFORCELong },
  },
  sap: {
    LIGHT: { S: SAP, L: SAPLong },
    DARK: { S: SAP, L: SAPLong },
  },
  share_point_one_drive: {
    LIGHT: { S: SHAREPOINT, L: SHAREPOINTLong },
    DARK: { S: SHAREPOINT, L: SHAREPOINT_LONG_DARK },
  },
  smartsheet: {
    LIGHT: { S: SMARTSHEET, L: SMARTSHEETLong },
    DARK: { S: SMARTSHEET_DARK, L: SMARTSHEET_LONG_DARK },
  },
  snowflake: {
    LIGHT: { S: SNOWFLAKE, L: SNOWFLAKELong },
    DARK: { S: SNOWFLAKE, L: SNOWFLAKELong },
  },
  "Snowflake Trust Center": {
    LIGHT: { S: SNOWFLAKE_TRUST_CENTER, L: SNOWFLAKE_TRUST_CENTERLong },
    DARK: {
      S: SNOWFLAKE_TRUST_CENTER_DARK,
      L: SNOWFLAKE_TRUST_CENTER_LONG_DARK,
    },
  },
  tableau: {
    LIGHT: { S: TABLEAU, L: TABLEAULong },
    DARK: { S: TABLEAU_DARK, L: TABLEAU_LONG_DARK },
  },
  trello: {
    LIGHT: { S: TRELLO, L: TRELLOLong },
    DARK: { S: TRELLO_DARK, L: TRELLO_LONG_DARK },
  },
  zoom: {
    LIGHT: { S: ZOOM, L: ZOOMLong },
    DARK: { S: ZOOM, L: ZOOMLong },
  },
  BloodHound: {
    LIGHT: { S: BLOODHOUND, L: BLOODHOUNDLong },
    DARK: { S: BLOODHOUND_DARK, L: BLOODHOUND_LONG_DARK },
  },
};
